import './error.scss';
import { useNavigate } from 'react-router-dom';
import { BrandButton } from './form/buttons';

const LoadError = () => {
    const navigate = useNavigate();
    return(
        <div className="loadError">
            <div className="errorContent">
            <p>There was an error loading your page. Please login and try again.</p>
            <BrandButton onClick={() => navigate('/', { replace: true })}>GO HOME</BrandButton>
            </div>
        </div>
    )
}
export default LoadError;